import { Route } from "@angular/router";
import { LoggerService } from "../services/logger.service";
import { inject } from "@angular/core";

/**
 * Interface defining a quiz navigation route
 */
export interface QuizNavigationItem {
  path: string;
  label: string;
  requiresExistingQuiz?: boolean;
  component?: any; // Used for router configuration
  loadComponent?: () => Promise<any>; // Used for lazy loading
  data?: Record<string, any>; // Additional route data
}

/**
 * Shared configuration for quiz navigation
 * This is the single source of truth for both the router configuration
 * and the navigation UI components
 */
export const QUIZ_NAVIGATION_ITEMS: QuizNavigationItem[] = [
  {
    path: '',
    label: 'Quiz Details',
  },
  {
    path: 'announcements',
    label: 'Announcements',
    requiresExistingQuiz: true,
  },
  {
    path: 'questions',
    label: 'Questions',
    requiresExistingQuiz: true,
  },
  {
    path: 'publication',
    label: 'Publication',
    requiresExistingQuiz: true,
  },
  {
    path: 'learners',
    label: 'Learners',
    requiresExistingQuiz: true,
  },
  {
    path: 'reports',
    label: 'Reports',
    requiresExistingQuiz: true,
  },
];
